import React, { FC, useContext, useEffect } from 'react'
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts'
import Title from '../Title'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { DataContext } from '../../contexts/DataProvider'
import { getChartDate } from '../../helpers/getChartDate'
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../../utils/colors'
import useFetch from '../../hooks/useFetch'
import { getPeriod } from '../../helpers/helpers'
import ChartLoader from '../ChartLoader'

interface Data {
  time: string
  activeAccounts?: number
  totalAccounts?: number
}

const Chart: FC = () => {
  const { period, startDate, endDate, activeContract, setError } = useContext(DataContext)
  const [isLoadingChart, chartData, error] = useFetch('getUsers', {}, [], {
    'studyIds[]': activeContract?.id,
    startTime: startDate.format('MM.DD.YYYY'),
    endTime: endDate.format('MM.DD.YYYY'),
    period: getPeriod(period),
    noLimits: true,
  })

  const results: Data[] =
    chartData?.data?.map((contract) => {
      const time = getChartDate(period, contract)
      return {
        time,
        activeAccounts: contract.activeCount,
        totalAccounts: contract.totalCount,
      }
    }) || []

  const StyledBox = styled(Box)(() => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    position: 'relative',
  }))

  useEffect(() => {
    if (!error) {
      return
    }
    setError({ isError: true, errorMessage: 'Error during fetching user chart data' })
  }, [error])

  return (
    <StyledBox>
      <Title>Users per contract:</Title>
      <ResponsiveContainer width="100%" height={280}>
        <LineChart width={730} height={200} data={results} margin={{ top: 5, right: 30, left: -10, bottom: 5 }}>
          <XAxis dataKey="time" fontSize={12} tickMargin={15} />
          <YAxis fontSize={12} tickMargin={10} />
          <Tooltip />
          <Line type="monotone" dataKey="totalAccounts" stroke={PRIMARY_COLOR} />
          <Line type="monotone" dataKey="activeAccounts" stroke={SECONDARY_COLOR} />
          <CartesianGrid strokeDasharray="3 3" />
        </LineChart>
      </ResponsiveContainer>

      {isLoadingChart && <ChartLoader />}
    </StyledBox>
  )
}
export default Chart
